// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IEmailCommunicationDestination } from './IEmailCommunicationDestination';
import {
    instanceOfIEmailCommunicationDestination,
    IEmailCommunicationDestinationFromJSON,
    IEmailCommunicationDestinationFromJSONTyped,
    IEmailCommunicationDestinationToJSON,
} from './IEmailCommunicationDestination';
import type { ILetterCommunicationDestination } from './ILetterCommunicationDestination';
import {
    instanceOfILetterCommunicationDestination,
    ILetterCommunicationDestinationFromJSON,
    ILetterCommunicationDestinationFromJSONTyped,
    ILetterCommunicationDestinationToJSON,
} from './ILetterCommunicationDestination';

/**
 * @type ICommunicationDtoDestination
 * 
 * @export
 */
export type ICommunicationDtoDestination = IEmailCommunicationDestination | ILetterCommunicationDestination;

export function ICommunicationDtoDestinationFromJSON(json: any): ICommunicationDtoDestination {
    return ICommunicationDtoDestinationFromJSONTyped(json, false);
}

export function ICommunicationDtoDestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICommunicationDtoDestination {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIEmailCommunicationDestination(json)) {
        return IEmailCommunicationDestinationFromJSONTyped(json, true);
    }
    if (instanceOfILetterCommunicationDestination(json)) {
        return ILetterCommunicationDestinationFromJSONTyped(json, true);
    }

    return {} as any;
}

export function ICommunicationDtoDestinationToJSON(json: any): any {
    return ICommunicationDtoDestinationToJSONTyped(json, false);
}

export function ICommunicationDtoDestinationToJSONTyped(value?: ICommunicationDtoDestination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIEmailCommunicationDestination(value)) {
        return IEmailCommunicationDestinationToJSON(value as IEmailCommunicationDestination);
    }
    if (instanceOfILetterCommunicationDestination(value)) {
        return ILetterCommunicationDestinationToJSON(value as ILetterCommunicationDestination);
    }

    return {};
}

